<template>
  <div class="setting-list">
    <div
      v-for="item in settingList"
      :key="item.id"
      class="setting-item"
      @click="handleClick(item)"
    >
     <div class="setting-item-content">
      <img :src="item.icon" alt="" />
      <div class="setting-item-value">{{ item.name }}</div>
     </div>
      <div class="setting-item-icon">
       <img src="@/assets/style/oride-icon.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { settingList } from "@/utils/const";

export default {
  name: "SettingList",
  data() {
    return {
      settingList,
    };
  },
  methods: {
    handleClick(item) {
      switch (item.id) {
        case 1:
          //协议
          this.$router.push({ name: "submitSign" });
          break;
        case 2:
          //账号安全
          this.$router.push({ name: "accountsAndSecurity" });
          break;
        case 3:
          console.log(item.id);
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.setting-list {
  padding: 20px 16px;
}
.setting-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 12px;
  padding: 0px 20px;
  height: 54px;
  font-weight: 500;
  .setting-item-content {
    flex: 1;
    display: flex;
    align-items: center;
    img {
      width: 25px;
      height: 25px;
      margin-right: 20px;
    }
  }
  .setting-item-icon {
    display: flex;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
